module.exports = __webpack_public_path__ + "static/media/APP_EarlyRiser_152x174_1.94e50783.png";